






































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import termCondiction from "@/models/termCondiction/termCondictioModel";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
@Component
export default class TermCondictionsAdd extends GenericAdd<termCondiction> {
  constructor() {
    super();
    this.controller = "TermCondictions";
    this.model = new termCondiction();

    Quill.register("modules/imageDrop", ImageDrop);
  }
  
  editorOption = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
        ["link", "image", "video"]
      ],
      imageDrop: true
    },
    placeholder: "Escriba el contenido aqui..."
  };
  public validarCodigo(event: any) {
    if (event.keyCode === 32) {
      event.preventDefault();
    }
  }
  public convertirAMinuscula(event: any) {
    this.model.key = event.target.value.toLowerCase();
  }
}
